import info from '@/assets/icons/info_blue.svg'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { AppTile } from "@/constants/classname/classname"
import { AppDispatch } from "@/redux"
import { workflowActions } from "@/redux/slice/workflowSlice"
import { useDispatch } from "react-redux"
import { ButtonVariant } from "@/constants/button/button"
import { AppAvailabilityStatus } from "@/constants/TCS/TCS"
import { Label } from "@/components/ui/label"
import { App } from '@/types/applications'
import { X } from 'lucide-react'

export const EditTaskApp = ({
  taskId,
  order,
  applications,
  isSelectAppModalOpen,
  setIsSelectModalOpen
}: {
  taskId: string,
  order: number,
  applications: App[],
  isSelectAppModalOpen: boolean,
  setIsSelectModalOpen: (val: boolean) => void
}) => {
  const dispatch: AppDispatch = useDispatch()

  const getClassNameWithStatus = (status: AppAvailabilityStatus) => {
    const appName = status === AppAvailabilityStatus.ACTIVE
      ? AppTile.ACTIVE_APP_NAME
      : AppTile.COMING_SOON_APP_NAME
    const cardComponent = status === AppAvailabilityStatus.ACTIVE
      ? AppTile.ACTIVE
      : AppTile.COMING_SOON

    return {
      appName,
      cardComponent
    }
  }

  return (
    <AlertDialog open={isSelectAppModalOpen} onOpenChange={() => setIsSelectModalOpen(false)}>
      <AlertDialogContent className="max-w-[910px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="mb-6">
            <div className="flex flex-row items-center justify-between">
              <AlertDialogFooter className="absolute right-6 top-6">
                <AlertDialogCancel asChild>
                  <Button className="p-0 rounded rounded-full" variant={ButtonVariant.ICON} size="icon">
                    <X />
                  </Button>
                </AlertDialogCancel>
              </AlertDialogFooter>
            </div>
          </AlertDialogTitle>
          <Label className="flex justify-start text-2xl leading-4 font-semibold text-primary pb-4" >
            Select app for this task
          </Label>
          <div className="flex mb-2 mr-2 w-full flex-wrap overflow-y-auto max-h-[500px] thin-scrollbar">
            {applications?.map((app, i) => {
              if (app.status === AppAvailabilityStatus.ACTIVE) {
                return (
                  <AlertDialogAction
                    key={app.id + i}
                    className={getClassNameWithStatus(app.status as AppAvailabilityStatus).cardComponent}
                    onClick={() => {
                      dispatch(workflowActions.updateStepApp({
                        oldAppId: taskId,
                        order: order,
                        newAppId: app.id
                      }))
                    }}
                  >
                    <img
                      src={app.logo}
                      className="h-8 flex flex-row items-center justify-center"
                    />
                    <p className={getClassNameWithStatus(app.status as AppAvailabilityStatus).appName}>
                      {app.displayName}
                    </p>
                  </AlertDialogAction>
                )
              } else {
                return (
                  <div
                    key={app.id}
                    className={getClassNameWithStatus(app.status as AppAvailabilityStatus).cardComponent}
                  >
                    <img
                      src={app.logo}
                      className="h-8 flex flex-row items-center justify-center"
                    />
                    <p className={getClassNameWithStatus(app.status as AppAvailabilityStatus).appName}>
                      {app.displayName}
                    </p>
                    {app.status === AppAvailabilityStatus.COMING_SOON && (
                      <div className="flex items-center">
                        <img src={info} className="mr-2" />
                        <p className="uppercase font-semibold leading-2 text-accent tracking-wide" style={{ fontSize: '10px' }}>
                          Coming Soon
                        </p>
                      </div>
                    )}
                  </div>
                )
              }
            })}
          </div>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  )
}
